import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import { useTranslation, Trans } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import "./newforgetpassword.module.css";


//services
import { forgotPassword } from "../../services/auth";

//reducer
import { setLoading } from "../../reducer/auth/auth";
import LanguageSwitcher from "../../components/languageSwitcher";

const NewForgetPassword = () => {
  //hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation("authLogin");

  //states
  const [emailError, setEmailError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    // Carousel functionality agar chahiye to yahan add karo
  }, []);

  const handleForgotPassword = async (formData) => {
    dispatch(setLoading(true));
    let item = {
      email: formData.email,
    };
    forgotPassword(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          // Show inline success message instead of modal
          setSuccessMessage(
            t("forgotPassword.emailSent")
          );
          setEmailError("");
        }
        if (!data.data.status && data.data.error) {
          setSuccessMessage("");
          setEmailError(data.data.error);
        }
        if (!data.data.status && data.data.error === "Unauthorized") {
          setSuccessMessage("");
          setEmailError(t("forgotPassword.invalidEmail"));
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };

  // Modal functions - SAME AS LOGIN PAGE
  const openRegistrationModal = () => {
   setShowModal(true);
    window.loadModal2("#myModal", "show");
  };
   useEffect(() => {
      const modalEl = document.getElementById("myModal");
  
      if (!modalEl) return;
  
      const handleHide = () => {
        setShowModal(false);
      };
  
      modalEl.addEventListener("hidden.bs.modal", handleHide);
  
      return () => {
        modalEl.removeEventListener("hidden.bs.modal", handleHide);
      };
    }, []);

  const redirectRoute = (item) => {
    navigate(item);
  };

  // SVG Icons - SAME AS LOGIN PAGE
  const EmailIcon = () => (
    <svg
      className="input-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 6L12 13L2 6"
        stroke="#6c757d"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <>
    <div className="login_body">
    

      <div className="header_login">
        <div className="header_container">
          <div className="header_left">
            <div className="logo">
              <img src="/images/logo-verysoul.png" alt={t("shared.logoAlt")} />
            </div>
          </div>
          <div className="header_right">
            <LanguageSwitcher className="header-language-switcher" />
            <span className="desktop-text">{t("shared.noAccount")}</span>
            <span className="mobile-text"></span>
            {/* CHANGED: onClick se modal nahi, navigate karega */}
            <button className="register-btn" onClick={openRegistrationModal}>
                {t("shared.register")}
              </button>
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="container-fluid login_content">
        <div className="row justify-content-center login_row">
          {/* Left Area - Testimonial */}
          {/* Left Area - Testimonial */}
          <div className="card_column col-md-6 text-white bg-dark login_left_area">
            <div className="card-body text-center">
              <div className="login_inner">
              <div className="text-center login-heading">
  <h2 className="d-none-text d-md-block real-text">{t("shared.tagline")}</h2> 
  <h2 className="d-block d-md-none"><Trans i18nKey="shared.taglineMultiline" ns="authLogin" t={t} /></h2>
</div>

              </div>
            </div>
          </div>
          {/* Right Area - Forgot Password Form */}
          <div className="card_column col-md-6 p-4 mb-0 login_right_area">
            <div className="login_inner">
              <div className="card-body">
                <h1>{t("forgotPassword.title")}</h1>

                {/* Email Error Display */}
                {emailError && (
                  <div className="alert alert-danger" role="alert">
                    {emailError}
                  </div>
                )}

                {/* Success Message Display (non-red) */}
                {successMessage && (
                  <div className="alert alert-success" role="alert">
                    {successMessage}
                  </div>
                )}

                <Formik
                  initialValues={{
                    email: "",
                  }}
                  validate={(values) => {
                    const errors = {};
                    if (!values.email) {
                      errors.email = t("forgotPassword.emailRequired");
                    } else if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
                        values.email
                      )
                    ) {
                      errors.email = t("common:validation.invalidEmail");
                    }
                    return errors;
                  }}
                  onSubmit={(values, { setSubmitting }) => {
                    handleForgotPassword(values);
                    setSubmitting(false);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                  }) => (
                    <form className="login_form" onSubmit={handleSubmit}>
                      <div className="mb-4 mt-4 form-group">
                        <label>{t("shared.emailLabel")}</label>
                        <div className="position-relative email-field-wrapper">
                          <div className="input-icon-wrapper">
                            <EmailIcon />
                          </div>
                          <input
                            className={`form-control ${
                              errors.email && touched.email
                                ? "error-boundry"
                                : ""
                            }`}
                            type="email"
                            name="email"
                            placeholder={t("shared.emailPlaceholder")}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                          />
                        </div>
                        {errors.email && touched.email && (
                          <div className="error-text mt-1">{errors.email}</div>
                        )}
                      </div>

                      <div className="row">
                        <div className="col-12">
                          <button
                            className="btn btn-primary px-4 login_button"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {t("forgotPassword.submit")}
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>

                <p className="text-body-secondary text-center mt-3">
                  <Link to="/login">{t("shared.backToLogin")}</Link>
                </p>
              </div>

              {/* Bottom Links */}
              <div className="login_bottom_area mt-4">
                <div className="login_bottom_content">
                  <div className="login_bottom_links">
                    <ul>
                      <li>
                        <Link to="/privacy-policy" target="_blank">
                          {t("common:common.privacyPolicy")}
                        </Link>
                      </li>
                      <li>
                        <Link to="/terms-conditions" target="_blank">
                          {t("common:common.termsConditions")}
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <p className="text- bookin">
                    <b>
                      {t("common:common.browserNote")}
                    </b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Success Modal - Reset Password - UNIQUE ID */}
      <div className="modal fade" id="successModal" role="dialog">
        <div className="modal-dialog modal-dialog-preview">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="/images/Union-icon.png" alt="Union-icon" />
              </div>
              <h3>{t("forgotPassword.successModal.title")}</h3>
              <p className="mt-4">
                <Trans i18nKey="forgotPassword.successModal.body" ns="authLogin" t={t} />
              </p>
              <div
                className="register-medium-confirnation"
                onClick={() => window.loadModal2("#successModal", "hide")}
              >
                {t("forgotPassword.successModal.close")}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Registration Modal - SAME AS LOGIN.JS */}
      {/* <div className="dont-have-acc">
        <div className="modal fade" id="registrationTypeModal" role="dialog">
          <div className="modal-dialog modal-dialog-preview">
            <div className="modal-content">
              <div className="modal-body text-align-unset">
                <div className="icon-pop text-align-center">
                  <img src="/images/Union-icon.png" alt="union-icon" />
                </div>
                <ul>
                  <li>
                    <div
                      onClick={() => redirectRoute("/registration")}
                      className="height-unset"
                      data-dismiss="modal"
                    >
                      <img src="/images/medum.png" alt="medium" />
                      <span data-dismiss="modal">
                        Register as <br />
                        Medium
                      </span>
                    </div>
                  </li>
                  <li>
                    <div
                      className="height-unset"
                      onClick={() => redirectRoute("/register-client")}
                      data-dismiss="modal"
                    >
                      <img src="/images/customer.png" alt="register" />
                      <span>
                        Register as <br />
                        Client
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
      {showModal && (
        <div className="dont-have-acc" onClick={() => setShowModal(false)}>
          <div
            className="modal fade"
            id="myModal"
            role="dialog"
            data-bs-backdrop="true"
            data-bs-keyboard="true"
          >
            <div
              className="modal-dialog modal-dialog-preview"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-body text-align-unset">
                  <div className="icon-pop text-align-center">
                    <img src="/images/Union-icon.png" alt="union-icon" />
                  </div>
                  <ul>
                    <li>
                      <div
                        onClick={() => redirectRoute("/registration")}
                        className="height-unset"
                        data-dismiss="modal"
                      >
                        <img src="/images/medum.png" alt="medium" />
                        <span data-dismiss="modal">
                          <Trans i18nKey="shared.registerAsMedium" ns="authLogin" t={t} />
                        </span>
                      </div>
                    </li>
                    <li>
                      <div
                        className="height-unset"
                        onClick={() => redirectRoute("/register-client")}
                        data-dismiss="modal"
                      >
                        <img src="/images/customer.png" alt="register" />
                        <span>
                          <Trans i18nKey="shared.registerAsClient" ns="authLogin" t={t} />
                        </span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NewForgetPassword;
